import { AxiosInstance } from 'axios';
import { useHttp } from '@Libs/http';
import { ConfigInterface, keyInterface, responseInterface } from 'swr';

interface RequestRatingDoctor {
    limit: number;
    offset: number;
}

interface RequestSearchDoctors {
    q?: string;
    filterSpecialties?: string[];
}

const doctorApi = (http: AxiosInstance) => {
    return {
        search: async (queries: RequestSearchDoctors, offset = 0, limit = 10) => {
            const response = await http.get('/doctor/search', {
                params: { ...queries, offset, limit },
            });
            return response.data;
        },
        getDoctorId: async (doctorId: string) => {
            const response = await http.get(`/doctor/${doctorId}`);
            return response.data || {};
        },
        getRatingDoctor: async (doctorId: string, queries?: RequestRatingDoctor) => {
            const response = await http.get(`/doctor/${doctorId}/list_ratings`, {
                params: {
                    offset: 0,
                    limit: 10,
                    ...queries,
                },
            });
            return response.data || {};
        },
        bookmark: async (doctorId: string) => {
            return await http.post(`/doctor/${doctorId}/bookmark`, {});
        },
        unBookmark: async (doctorId: string) => {
            return await http.post(`/doctor/${doctorId}/un_bookmark`);
        },
    };
};

export const DOCTOR_ID_KEY = 'doctorid_key';
export const useDoctor = (doctorId: string, config?: ConfigInterface, key = DOCTOR_ID_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ userHttp }) => await doctorApi(userHttp).getDoctorId(doctorId), config);

export const SEARCH_DOCTORS_KEY = 'search_doctors_key';
export const useSearchDoctor = (queries: RequestSearchDoctors, offset = 0, limit = 10, config?: ConfigInterface, key: keyInterface = SEARCH_DOCTORS_KEY): responseInterface<any, any> => {
    return useHttp(
        key,
        async ({ userHttp }) => {
            const { doctors } = await doctorApi(userHttp).search(queries, offset, limit);
            return doctors;
        },
        config,
    );
};

export const RATING_DOCTOR_KEY = 'rating_doctor_key';
export const useRatingDoctor = (doctorId: string, queries?: RequestRatingDoctor, key = RATING_DOCTOR_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ userHttp }) => await doctorApi(userHttp).getRatingDoctor(doctorId, queries));

export default doctorApi;
